import { Autocomplete, Switch, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { useAppData } from '../../../../../context/AppDataContext';
import poServices from '../../po/poServices';
import { useAlert } from '../../../../../context/AlertContext';


export const  POTransactionAllocationForm = ({transactionAmount,poTransactionList,setPoTransactionList,totalAlloted,setTotalAlloted}) => {
    const {vendorDD,projectDD} = useAppData();
    const [vendor,setVendor] = useState();
    const {AppAlert}  = useAlert();

    const getVendorPoList = () =>{
        if(vendor){
            poServices.getByVendorId(vendor.value).then(res=>{
                //res.data.forEach(obj => obj.amount = 0);
                let ta = res.data.map((po=>{
                        return({
                            poId:po.id,
                            payeeType:2,
                            payeeId:po.vendorId,
                            projectId:po.projectId,
                            poNo:po.poNo,
                            grandTotal:po.grandTotal,
                            paidAmount:po.paidAmount,
                            pendingAmount:po.grandTotal - po.paidAmount,
                            amount:"",
                        })
                    }
                ))
                setPoTransactionList(ta);
            }).catch(error=>{
                console.log("Error Faching Vendor Po List");
            }).finally(()=>{
            })
        }
    }


    
    const setInputAmount = (i, amt) => {
        let amount = Number(amt) || 0; // Use 0 instead of "" for math safety
        let _poTransactionList = [...poTransactionList];

        // 1. Calculate the total of OTHER items (excluding the one being edited)
        let totalOfOthers = _poTransactionList.reduce((sum, item, index) => {
            return index === i ? sum : sum + (Number(item.amount) || 0);
        }, 0);

        // 2. Calculate what the new total WOULD be
        let projectedTotal = totalOfOthers + amount;

        // Validation Logic
        if (projectedTotal <= transactionAmount) {
            if (amount <= _poTransactionList[i].pendingAmount) {
                _poTransactionList[i]['amount'] = amount;

                setPoTransactionList(_poTransactionList);

                setTotalAlloted(projectedTotal);
            } else {
                AppAlert("Amount should not exceed pending amount", 'error');
            }
        } else {
            AppAlert("Total Amount should not exceed transaction amount", 'error');
        }
    };

    useEffect(()=>{
        getVendorPoList();
    },[vendor])

    return (
        <>
            
            <table className='table table-bordered table-striped'>
                <thead>
                    <tr className='table-dark text-white  border-primary'>
                        <th >Select Vendor</th>
                        <th colSpan={2} className='text-center'>
                            <Autocomplete
                                options={vendorDD}
                                onChange={(event, newValue) => {
                                    setVendor(newValue);
                                }}
                                className='bg-white'
                                value={vendor}
                                renderInput={(params) => <TextField {...params} size="small" /> } 
                            />
                        </th>
                    </tr>
                </thead>
                {poTransactionList?.length > 0 &&
                <tbody>
                    <tr className='table-primary border-primary'>
                        <th>PO Details</th>
                        <th>Previous Pending Amount</th>
                        <th width="30%">Amount</th>
                        <th>Current Pending</th>
                    </tr>
                        {poTransactionList && poTransactionList.map((po,i)=>
                            <tr key={i}>
                                <td>
                                    {po.poNo},
                                </td>
                                <td>
                                    {po.pendingAmount}
                                </td>
                                <td>
                                    <input type="number" className='form-control' value={po.amount}
                                        onChange={(e)=>setInputAmount(i,e.target.value)}
                                    />
                                </td>
                                <td>
                                    {po.pendingAmount - po.amount}
                                </td>
                            </tr>
                            
                        )}
                        <tr>
                            <td></td>
                            <th>Alloted</th>
                            <th>
                                {totalAlloted} / {transactionAmount}. <span className='bg-warning p-2'>{transactionAmount-totalAlloted} Pending</span>
                            </th>
                            <td></td>
                        </tr>
                        <tr>
                            <td colSpan={4}> {  /* JSON.stringify(poTransactionList) */}</td>
                        </tr>
                    </tbody>
                }
                {poTransactionList?.length == 0 &&
                    <tbody>
                        <tr>
                            <td className='text-center' colSpan={2}>No po found for {vendor?.label}</td>
                        </tr>
                        
                    </tbody>
                }
            </table>
        </>
    )
}

